
import React, { useState, useEffect } from 'react';
import { FilterOptions } from '../types';
import { advisors } from '../data/advisorsData'; // 👈 import static data

interface SearchFiltersProps {
  onFilterChange: (filters: FilterOptions) => void;
}

const SearchFilters: React.FC<SearchFiltersProps> = ({ onFilterChange }) => {
  const [specializations, setSpecializations] = useState<string[]>([]);
  const [locations, setLocations] = useState<string[]>([]);
  const [filters, setFilters] = useState<FilterOptions>({});

useEffect(() => {
  const uniqueSpecializations = Array.from(
    new Set(advisors.flatMap((advisor) => advisor.specializations))
  ).sort();

  const uniqueLocations = Array.from(
    new Set(advisors.map((advisor) => advisor.location))
  ).sort();

  setSpecializations(uniqueSpecializations);
  setLocations(uniqueLocations);
}, []);





  const handleFilterChange = (key: keyof FilterOptions, value: string | number | undefined) => {
    const newFilters = { ...filters, [key]: value || undefined };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-8">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Find Advisors</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Specialization Filter */}
        <div>
          <label htmlFor="specialization" className="block text-sm font-medium text-gray-700 mb-2">
            Specialization
          </label>
          <select
            id="specialization"
            value={filters.specialization || ''}
            onChange={(e) => handleFilterChange('specialization', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
          >
            <option value="">All Specializations</option>
            {specializations.map((spec) => (
              <option key={spec} value={spec}>
                {spec}
              </option>
            ))}
          </select>
        </div>

        {/* Location Filter */}
        <div>
          <label htmlFor="location" className="block text-sm font-medium text-gray-700 mb-2">
            Location
          </label>
          <select
            id="location"
            value={filters.location || ''}
            onChange={(e) => handleFilterChange('location', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
          >
            <option value="">All Locations</option>
            {locations.map((loc) => (
              <option key={loc} value={loc}>
                {loc}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Clear Filters Button */}
      <div className="mt-4">
        <button
          onClick={() => {
            setFilters({});
            onFilterChange({});
          }}
          className="text-primary-600 hover:text-primary-700 text-sm font-medium"
        >
          Clear all filters
        </button>
      </div>
    </div>
  );
};

export default SearchFilters;
